import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from "@core/components/Dialog";
import { cancelarAlert } from 'app/services/alerts';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext } from 'react';
import { ProdutoContext } from "../../ProdutoContext";
import { produtoModais } from "../modal/produtoModais";
import ProdutoBuscaAvancadaForm from './ProdutoBuscaAvancadaForm';


const ProdutoBuscaAvancada = ({ fetchProdutos }) => {
  const [modal, setModal] = useContext(ProdutoContext).modal;
  const [filtroAvancado, setFiltroAvancado] = useContext(ProdutoContext).filtroAvancado;
  const [search] = useContext(ProdutoContext).search;
  const [size] = useContext(ProdutoContext).size;
  const [sort] = useContext(ProdutoContext).sort;


  const handleCancelar = ( ) => {
    if (formik.dirty){
      cancelarAlert({
        confirmar: () => {
          formik.resetForm(formik.initialValues)
          setModal('')
        }
      })
    } else {
      setModal('');
    }
  };

  const handleSubmit = (values) => {

    const filtroAvancado = {
      ...values,
      inativo: values?.inativo === "TRUE" ? true 
             : values?.inativo === "FALSE" ? false : null
    }
    
    setFiltroAvancado(values);
    fetchProdutos({q: search, filtroAvancado, size, sort });
    setModal('');
  };

  const formik = useFormik({
    initialValues: {
      nome: filtroAvancado.nome,
      codigo: filtroAvancado.codigo,
      inativo: filtroAvancado.inativo,
      tipoFinalidade: filtroAvancado.tipoFinalidade,
      promocao: filtroAvancado.promocao,
    },
    onSubmit: handleSubmit
  });

  return (
    <SimpleDialog open={modal === produtoModais.buscaAvancada} onClose={handleCancelar}>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          header={{
            title: 'Busca avançada',
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" 
                onClick={handleCancelar}
                >
                  Cancelar
                </CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Aplicar
                </SaveButton>
              </>
            ),
          }}
          content={<ProdutoBuscaAvancadaForm/>}
          contentStyle={{ padding: 0 }}
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default ProdutoBuscaAvancada;